export class User {
    FullName: string="";
    Email: string="";
    UserRole: string="";
}
